import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/http";

export function companyQueryOptions() {
  return queryOptions({
    queryKey: ["company"],
    queryFn: () => api.company.getCompany(),
  });
}

export function useCompany() {
  return useQuery(companyQueryOptions());
}

export function templatePoliciesQueryOptions() {
  return queryOptions({
    queryKey: ["policies", "templates"],
    queryFn: () => api.company.getTemplatePolicies(),
  });
}

export function useTemplatePolicies() {
  return useQuery(templatePoliciesQueryOptions());
}

export function seatsQueryOptions() {
  return queryOptions({
    queryKey: ["company", "seats"],
    queryFn: () => api.company.getSeats(),
  });
}

export function useSeats() {
  return useQuery(seatsQueryOptions());
}
